import { fromWorker } from 'observable-webworker';
import { Observable } from 'rxjs';

export function runInSandbox<T = unknown>(input$: Observable<string>) {
  return fromWorker<string, T>(
    () =>
      new Worker(
        new URL(
          '@epicuro-next/workers/sandbox/sandbox.worker',
          import.meta.url,
        ),
        {
          type: 'module',
        },
      ),
    input$,
  );
}
